import { StreemApiCallLogEntry } from '@streem/api';
import { HostCallLogDetails } from '@streem/sdk-react';

export const processCallLogDetails = (
    callLogEntries: StreemApiCallLogEntry[],
): HostCallLogDetails[] => {
    return callLogEntries
        .filter(callEntry => !callEntry.missed)
        .map(callLogEntry => {
            return {
                ...callLogEntry,
                callDetailsUrl: `/teamcalls/${callLogEntry.roomSid}`,
                urlHostname: window.location.hostname,
            };
        });
};
